import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { toast } from "react-toastify";

import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TextFormEditor from "./../../../component/atoms/input/textFormEditor";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import PretendardText from "../../../component/atoms/text/pretendardText";
import TermApi from "../../../api/term.api";
import { errorHandler } from "../../../util/errorHandler";
import scrollToTop from "../../../util/scrollToTop";
import { toastMsg } from "../../../util/toastMsg";
import { route } from "../../../router/route";

const OperationTerms = () => {
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.operation_terms)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [tab, setTab] = useState({
    agreement: true,
    personal: false,
    refund: false,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [content, setContent] = useState("");
  const [termData, setTermData] = useState({
    content: "",
    createdAt: "",
    id: 0,
    termType: "",
    updatedAt: "",
  });

  useEffect(() => {
    if (tab.agreement) {
      getTermDetailFunc(1);
      return;
    }

    if (tab.personal) {
      getTermDetailFunc(2);
      return;
    }

    if (tab.refund) {
      getTermDetailFunc(3);
      return;
    }
  }, [tab]);

  // 약관 관리 데이터 가져오기
  const getTermDetailFunc = async (id) => {
    try {
      const response = (await TermApi.getTermDetail(id)).data.data.content;
      setTermData(response);
      setContent(response.content);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 약관 관리 수정하기
  const editTermDetailFunc = async () => {
    try {
      const data = {
        id: termData.id,
        content: content,
        termType: termData.termType,
      };

      await TermApi.editTerm(termData.id, data);

      getTermDetailFunc(termData.id);
      toast(toastMsg.create);
      scrollToTop();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>약관 관리</TableTitle>
          <TabWrapper>
            <Tab
              isActive={tab.agreement}
              onClick={() => {
                setTab({
                  agreement: true,
                  personal: false,
                  refund: false,
                });
              }}
            >
              <TabText isActive={tab.agreement}>이용약관</TabText>
            </Tab>
            <Tab
              isActive={tab.personal}
              onClick={() => {
                setTab({
                  agreement: false,
                  personal: true,
                  refund: false,
                });
              }}
            >
              <TabText isActive={tab.personal}>개인정보처리방침</TabText>
            </Tab>
            <Tab
              isActive={tab.refund}
              onClick={() => {
                setTab({
                  agreement: false,
                  personal: false,
                  refund: true,
                });
              }}
            >
              <TabText isActive={tab.refund}>환불정책</TabText>
            </Tab>
          </TabWrapper>
          <TextFormEditor
            placeholder={"상세 내용을 입력해주세요"}
            value={content}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onChange={(e) => {
              setContent(e);
            }}
            editorHeight={600}
            style={{
              width: "100%",
            }}
          />
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            {isWriteAuthority && (
              <BasicBtn
                onClick={() => {
                  editTermDetailFunc();
                }}
              >
                저장하기
              </BasicBtn>
            )}
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default OperationTerms;

const TabWrapper = styled.div.attrs((props) => {})`
  width: fit-content;
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 32px;
`;

const Tab = styled.div.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 19px 34.5px;
  border-bottom: ${(props) => (props.isActive ? "2px solid #27beff" : "none")};
  cursor: pointer;
`;

const TabText = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: -0.3%;
  color: ${(props) =>
    props.isActive ? "#27beff" : "rgba(181, 181, 181, 0.5)"};
`;
